import { render, staticRenderFns } from "./UploadVideoFrame.vue?vue&type=template&id=09601707"
import script from "./UploadVideoFrame.vue?vue&type=script&lang=ts"
export * from "./UploadVideoFrame.vue?vue&type=script&lang=ts"
import style0 from "./UploadVideoFrame.vue?vue&type=style&index=0&id=09601707&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports